/**
 * Job title + work-type presets. Seeded with common contractor values and
 * extended with anything the user adds — kept in this browser for the signed-in
 * user (utils/storage) so new entries are offered again next time. Combined at
 * read-time with values already seen on live jobs (passed in by the caller).
 */
import { storageGet, storageSet } from './storage';

const TITLE_KEY = 'job_title_presets';
const WORKTYPE_KEY = 'work_type_presets';

const SEED_TITLES = [
  'LOLER thorough examination',
  'Facade anchor LOLER test',
  'BMU annual service',
  'Roof anchor recertification',
  'Staircase inspection',
  'Emergency lighting check',
  'Window cleaning cradle test',
  'Gutter clearance and survey',
  'Insurance inspection',
  'WAH risk assessment review',
];

const SEED_WORK_TYPES = [
  'LOLER Examination',
  'Asset Condition Survey',
  'Work at Height RA',
  'Planned Maintenance',
  'Maintenance',
  'Support Work',
  'Electrical',
  'Fabric Repair',
  'Gutter Clearance',
];

const read = (key, seed) => {
  const arr = storageGet(key, null);
  if (Array.isArray(arr)) return [...new Set([...seed, ...arr])];
  return [...seed];
};

const add = (key, seed, value) => {
  const v = String(value || '').trim();
  if (!v) return read(key, seed);
  const saved = storageGet(key, []);
  let custom = Array.isArray(saved) ? saved : [];
  if (![...seed, ...custom].some((x) => String(x).toLowerCase() === v.toLowerCase())) {
    custom = [...custom, v];
    storageSet(key, custom);
  }
  return read(key, seed);
};

export const getJobTitles = () => read(TITLE_KEY, SEED_TITLES);
export const saveJobTitle = (v) => add(TITLE_KEY, SEED_TITLES, v);
export const getWorkTypes = () => read(WORKTYPE_KEY, SEED_WORK_TYPES);
export const saveWorkType = (v) => add(WORKTYPE_KEY, SEED_WORK_TYPES, v);

/** Merge presets with values already seen on live data, sorted, deduped (case-insensitive). */
export const mergePresets = (presets, seen = []) => {
  const out = [];
  const lower = new Set();
  [...presets, ...seen].forEach((v) => {
    const s = String(v || '').trim();
    if (s && !lower.has(s.toLowerCase())) { lower.add(s.toLowerCase()); out.push(s); }
  });
  return out.sort((a, b) => a.localeCompare(b));
};
